import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ReportFormService } from './service/report-form.service';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { presetInterface } from 'src/app/util/interfaces/preset';
import { iacOptionInterface } from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.component';
import { CmdbSearchFilterService } from 'src/app/page_component/cmdb-search-filter/service/cmdb-search-filter.service';
import { RequestCustomfieldService } from 'src/app/page_component/request-customfield/service/request-customfield.service';
import { genericFormI } from 'src/app/util/interfaces/genericFormRMK';
import { reportColumnInterface } from './interface/reportColumnInterface';
import { forkJoin } from 'rxjs';

@Component({
	selector: 'app-report-form',
	templateUrl: './report-form.component.html',
	styleUrls: ['./report-form.component.scss'],
})
export class ReportFormComponent implements OnInit {
	@Input()
	labels: {
		lbl_rep_custom_nome: '';
		lbl_create_report: '';
		lbl_geral_atualizar: '';
		lbl_geral_criado_com_sucesso: '';
		lbl_preencha_todos_campos: '';
		lbl_geral_selecione_filtro: '';
		lbl_successful_updated: '';
		lbl_geral_preencha_todos_campos: '';
		lbl_geral_predefinicoes_de_colunas_para_serem_exportadas_na_planilha: 'Column presets to be exported in the spreadsheet';
		lbl_geral_procurar_por_uma_predefinicao: 'Search for a Preset';
		lbl_selecione_filtro_de_data: 'Select at least one date filter';
		lbl_geral_preencha_campo_obrigatorio: 'Please fill all the mandatory fields';
		lbl_procurar_predefinicao_colunas: '';
		lbl_selecione_pelo_menos_uma_coluna_relatorio: '';
	};

	@Output()
	goToHub = new EventEmitter();

	constructor(
		private ReportFormService: ReportFormService,
		private NotificationService: NotificationService,
		private CmdbSearchFilterService: CmdbSearchFilterService,
		private RequestCustomfieldService: RequestCustomfieldService
	) {}

	@Input()
	reportType: { name: 'request' | 'cmdb' | 'stock' | 'evaluate'; label: string };
	@Input()
	reportSubType: { name: string; label: string };
	@Input()
	idReport: string;

	@Input()
	formStage: 'register' | 'edit';

	isLoadingFormOptions = true;
	isLoadingReportParams = false;
	isLoadingFormItems = false;
	isUpdatingReport = false;
	isLoadingReportColumns = false;

	isFirstLoading = true;

	nameReport = '';
	reportFormDictionary = {};
	reportFormOptions: genericFormI[] = [];
	selectedFormOptions: genericFormI[] = [];

	columnPresetList: presetInterface[] = [];
	columnPresetListIAC: iacOptionInterface[] = [];
	setInputText = '';
	clearValuesPreset = false;
	placeholderPreset = '';
	hasDateInput = false;
	dateInputFilled = false;
	solutionAreaInputFilled = false;

	columnCustomPresetInterface = {
		id: '',
		typePreset: '',
		namePreset: '',
		notes: '',
		active: '',
		columns: [],
	};

	availableColumns: { id: string; name: string; label: string }[] = [];
	availableColumnsForm: genericFormI[] = [];

	ngOnInit(): void {
		this.ReportFormService.getForm(this.reportType.name, this.reportSubType.name).subscribe({
			next: (reportForm) => {
				this.setReportForm(reportForm);
			},
		});

		if (!this.idReport || this.idReport == '') {
			this.ReportFormService.getInitialSelectedColumns(this.reportType.name, this.reportSubType.name).subscribe({
				next: (selectedColumns) => {
					this.setAvailableColumns(selectedColumns);
				},
				error: () => {
					this.setAvailableColumns([]);
				},
			});
		}

		if (this.reportSubType.name === 'general') {
			this.ReportFormService.getPresetByType(this.reportType.name).subscribe({
				next: (presets) => {
					this.columnPresetList = [];
					this.columnPresetListIAC = [];
					this.columnPresetList = presets;
					for (const item of this.columnPresetList) {
						const newIacOptionLocation: iacOptionInterface = {
							name: item.namePreset + ', ' + item.notes,
							value: item.id,
							// "commonGroup": item.active === 1 ? this.labels.lbl_geral_ativo : this.labels.lbl_status_desativado
						};
						this.columnPresetListIAC.push(newIacOptionLocation);
					}
				},
			});
		}
	}

	setReportForm(form: genericFormI[]): void {
		this.hasDateInput = false;
		this.solutionAreaInputFilled = false;
		this.reportFormOptions = form;
		this.reportFormDictionary = {}; // Limpa o dicionário antes de preenchê-lo novamente

		for (const option of this.reportFormOptions) {
			if (option.inputType === 'period-date') {
				this.hasDateInput = true;
			}

			if (option.inputType === 'multi-select' && option.name === 'solutionArea' && option.values.length === 0) {
				this.solutionAreaInputFilled = true;
			}

			this.reportFormDictionary[option.name] = option;
		}

		if (this.idReport) {
			this.isLoadingFormOptions = true;
			this.isLoadingReportParams = true;

			// Fazer ambas as chamadas antes de processar os parâmetros
			forkJoin({
				columns: this.ReportFormService.getReportAvailableColumns(this.reportType.name, this.reportSubType.name),
				params: this.ReportFormService.getReportParams(this.idReport),
			}).subscribe(({ columns, params }) => {
				this.setAvailableColumns(params.column);

				if (this.reportType.name === 'cmdb' && this.reportSubType.name === 'general') {
					if (params.dictionary['type'] && params.dictionary['type'][0] !== '') {
						this.CmdbSearchFilterService.getAvailableFilters(params.dictionary['type'][0], []).subscribe((form) => {
							const temporaryFormOptions = [...this.reportFormOptions];

							for (const formItem of form) {
								const pFormItem = new genericFormI(<any>formItem.inputType);
								pFormItem.name = formItem.name;
								pFormItem.label = formItem.label;
								pFormItem.values = formItem.values;
								pFormItem.rawValues = formItem.rawValues;
								if (formItem.commonGroup !== '1A') temporaryFormOptions.push(pFormItem);
							}

							this.finalizeFormSetup(temporaryFormOptions, params);
						});
					} else {
						this.finalizeFormSetup(this.reportFormOptions, params);
					}
				} else {
					this.finalizeFormSetup(this.reportFormOptions, params);
				}
			});
		} else {
			this.isLoadingFormOptions = false;
			this.isLoadingReportParams = false;
		}
	}

	finalizeFormSetup(formOptions: genericFormI[], parameters: any): void {
		this.columnCustomPresetInterface.id = parameters.idPreset;
		this.nameReport = parameters.report_name;
		this.reportFormOptions = this.fillFormWithValues(formOptions, parameters.params);

		// Agora podemos definir como `false`, pois tudo foi carregado corretamente
		this.isLoadingFormOptions = false;
		this.isLoadingReportParams = false;
	}

	fillFormWithValues(availableForm: genericFormI[], parameters: any): genericFormI[] {
		const availableFormDict = {};
		for (const formItem of availableForm) {
			availableFormDict[formItem.id] = formItem;
		}
		for (const parameter of parameters) {
			if (availableFormDict[parameter.id_param]) {
				const formItem: genericFormI<'multi-select'> = availableFormDict[parameter.id_param];

				// if(param.items.length > 0) {
				//   formItem.items = param.items;
				// }

				formItem.values = [];
				formItem.rawValues = [];
				formItem.items = [];

				// Se o relatorio possuir parametros de filtro, coleta os items do filtro
				this.ReportFormService.getFormItem(parameter.id_param).subscribe((items) => {
					formItem.items = items;
					const formInputType = formItem.inputType.toString();
					if (formInputType === 'multi-select') {
						//Value in items
						for (const item of formItem.items) {
							if (parameter.param_value.includes(item.values[0].toString())) {
								formItem.values.push(item);
								formItem.rawValues.push(item.values[0]);
							}
						}
					} else if (formInputType.includes('date')) {
						//No join with §
						if (Number.isNaN(Date.parse(parameter.param_value[0])))
							availableFormDict[parameter.id_param].periodType = parameter.param_value[0];
						availableFormDict[parameter.id_param].values = parameter.param_value;
					} else {
						availableFormDict[parameter.id_param].values[0] = parameter.param_value.join('§');
					}
				});

				// let formInputType = formItem.inputType.toString();
				// if(formInputType === 'multi-select') { //Value in items
				//   formItem.items.forEach(item => {
				//     if(param.param_value.includes(item.values[0].toString())) {
				//       formItem.values.push(item)
				//       formItem.rawValues.push(item.values[0]);
				//     }
				//   })
				// } else if(formInputType.includes('date')) { //No join with §
				//   if(Number.isNaN(Date.parse(param.param_value[0]))) availableFormDict[param.id_param].periodType = param.param_value[0];
				//   availableFormDict[param.id_param].values = param.param_value;
				// } else {
				//   availableFormDict[param.id_param].values[0] = param.param_value.join('§');
				// }
				availableFormDict[parameter.id_param].selected = true;
				this.selectedFormOptions.push(availableFormDict[parameter.id_param]);
			}
		}

		return availableForm;
	}

	parseSelected(selectedForm: string): void {
		this.selectedFormOptions = JSON.parse(selectedForm);
	}

	getFormItems(): void {
		const lastSelectFormItem = this.selectedFormOptions.at(-1);
		//Customfields already come with items available
		if (lastSelectFormItem.commonGroup === 'CF') return;
		this.isLoadingFormItems = true;

		this.ReportFormService.getFormItem(lastSelectFormItem.name).subscribe((formItems) => {
			lastSelectFormItem.items = formItems;
			this.reportFormDictionary[lastSelectFormItem.name].items = formItems;

			if (lastSelectFormItem.items.length > 0) {
				lastSelectFormItem.inputType = 'multi-select';
				lastSelectFormItem.values = [];
				lastSelectFormItem.rawValues = [];

				this.reportFormDictionary[lastSelectFormItem.name].inputType = 'multi-select';
				this.reportFormDictionary[lastSelectFormItem.name].values = [];
				this.reportFormDictionary[lastSelectFormItem.name].rawValues = [];
			}
			this.isLoadingFormItems = false;
		});
	}

	createReport(): void {
		if (this.isUpdatingReport) return;

		this.isUpdatingReport = true;
		if (this.isReportFormAllFulfilled()) {
			const columns: reportColumnInterface[] = this.availableColumnsForm[0].values.map((columnValues) => {
				return {
					id: columnValues.id,
					name: columnValues.id,
					label: columnValues.label,
					colType: '',
				};
			});

			this.ReportFormService.createReport(
				this.nameReport,
				this.selectedFormOptions,
				this.reportType.name,
				this.reportSubType.name,
				columns
			).subscribe(() => {
				this.isUpdatingReport = false;
				this.NotificationService.setNotificationMessage(this.labels.lbl_geral_criado_com_sucesso);
				this.emitGoToHub();
			});
		} else {
			this.isUpdatingReport = false;
		}
	}

	isReportFormAllFulfilled(): boolean {
		this.dateInputFilled = false;
		if (this.nameReport === '') {
			this.NotificationService.setNotificationMessage(this.labels.lbl_preencha_todos_campos);
			return false;
		}

		// Criar sem nenhum filtro
		// if(this.reportFormOptions.length > 0 && this.selectedFormOptions?.length === 0){
		//   this.NotificationService.setNotificationMessage(this.labels.lbl_geral_selecione_filtro);
		//   return false;
		// };

		for (const formItem of this.selectedFormOptions) {
			if (formItem.values?.length === 0 || formItem.values[0] === '') {
				this.NotificationService.setNotificationMessage(this.labels.lbl_preencha_todos_campos);
				false;
				continue;
			} else if (formItem.inputType && formItem.inputType == 'period-date') {
				this.dateInputFilled = true;
			} else if (formItem.name == 'solutionArea' && formItem.values.length > 0) {
				this.solutionAreaInputFilled = false;
			}
		}

		if (this.solutionAreaInputFilled) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_geral_preencha_campo_obrigatorio);
			return false;
		}

		if (this.hasDateInput && !this.dateInputFilled) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_selecione_filtro_de_data);
			return false;
		}

		if (this.availableColumnsForm[0].items.length > 0 && this.availableColumnsForm[0].values.length === 0) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_selecione_pelo_menos_uma_coluna_relatorio);
			return false;
		}

		return true;
	}

	updateReport(): void {
		if (this.isUpdatingReport) return;

		this.isUpdatingReport = true;
		if (this.isReportFormAllFulfilled()) {
			const columns: reportColumnInterface[] = this.availableColumnsForm[0].values.map((columnValues) => {
				return {
					id: columnValues.id,
					name: columnValues.id,
					label: columnValues.label,
					colType: '',
				};
			});

			this.ReportFormService.updateReport(this.idReport, this.nameReport, this.selectedFormOptions, columns).subscribe(
				() => {
					this.NotificationService.setNotificationMessage(this.labels.lbl_successful_updated);
					this.isUpdatingReport = false;
					this.emitGoToHub();
				},
				() => {
					this.isUpdatingReport = false;
				}
			);
		} else {
			//this.NotificationService.setNotificationMessage(this.labels.lbl_geral_preencha_todos_campos);
			this.isUpdatingReport = false;
		}
	}

	emitGoToHub(): void {
		this.goToHub.emit(true);
	}

	getPreset(idPreset: string) {
		const selectedPreset = this.columnPresetList.find((v) => {
			return v.id == idPreset;
		});

		this.availableColumnsForm[0].values = [];
		this.availableColumnsForm[0].rawValues = [];

		for (const item of this.availableColumnsForm[0].items) {
			if (selectedPreset.columns.includes(item.id)) {
				this.availableColumnsForm[0].values.push(item);
				this.availableColumnsForm[0].rawValues.push(item.id);
			}
		}
	}

	setAvailableColumns(autoSelect: any): void {
		this.isLoadingReportColumns = true;
		this.ReportFormService.getReportAvailableColumns(this.reportType.name, this.reportSubType.name).subscribe({
			next: (availableColumns) => {
				this.availableColumns = availableColumns;
				const availableColumnFormItem = new genericFormI('multi-select');
				availableColumnFormItem.name = 'availableColumn';
				availableColumnFormItem.label = 'lbl_selecione_coluna_exibir_relatorio';

				availableColumns.sort((a, b) => {
					const la = this.labels[a.label] ? this.labels[a.label] : a.label;
					const lb = this.labels[b.label] ? this.labels[b.label] : b.label;
					return la > lb ? 1 : la < lb ? -1 : 0;
				});

				for (const column of this.availableColumns) {
					const newFormItem: genericFormI<'item'> = {
						id: column.id,
						name: column.name,
						label: column.label,
						values: [column.id],
						rawValues: [column.id],
						inputType: 'item',
					};

					if (autoSelect.includes(column.id)) {
						availableColumnFormItem.values.push(newFormItem);
						availableColumnFormItem.rawValues.push(column.id);
					}

					availableColumnFormItem.items.push(newFormItem);
				}

				this.availableColumnsForm = [availableColumnFormItem]; // Substitui corretamente os dados
			},
			error: (error) => {
				console.error('Erro ao buscar colunas disponíveis:', error);
				this.isLoadingReportColumns = false;
			},
			complete: () => {
				this.isLoadingReportColumns = false;
			},
		});
	}
}
